import { render, staticRenderFns } from "./CreateFolderModal.vue?vue&type=template&id=60099d58"
import script from "./CreateFolderModal.vue?vue&type=script&lang=js"
export * from "./CreateFolderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports